// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const ZipExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 37 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={0.832764} width={36} height={36} rx={8} fill="#5E7398" />
				<path
					opacity={0.8}
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.168 0H18.8328V1.83241H15.168V0ZM15.168 7.33002H18.8328V9.16243H15.168V7.33002ZM18.8328 3.66455H15.168V5.49696H18.8328V3.66455ZM15.168 10.9946H18.8328V12.827H15.168V10.9946ZM18.8328 14.6591H15.168V16.4915H18.8328V14.6591ZM18.8328 1.83228H22.4976V3.66469H18.8328V1.83228ZM22.4976 9.16229H18.8328V10.9947H22.4976V9.16229ZM18.8328 5.49683H22.4976V7.32924H18.8328V5.49683ZM22.4976 12.8268H18.8328V14.6593H22.4976V12.8268ZM18.8328 16.4914H22.4976V18.3238H18.8774C19.8687 18.3476 20.665 19.1586 20.665 20.1557V22.9043H17.0002V20.1557C17.0002 19.1437 17.8206 18.3233 18.8326 18.3233C18.8327 18.3233 18.8327 18.3233 18.8328 18.3233V16.4914ZM17.9164 21.0725C17.9164 20.5665 18.3266 20.1563 18.8326 20.1563C19.3386 20.1563 19.7488 20.5665 19.7488 21.0725C19.7488 21.5785 19.3386 21.9887 18.8326 21.9887C18.3266 21.9887 17.9164 21.5785 17.9164 21.0725Z"
					fill="white"
				/>
			</Svg>
		);
	}
);
ZipExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default ZipExtension;
